
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';

import ShowPrice from './ShowPrice';

import s from "./ListingItem.css";
import cx from 'classnames';

class TotalPricePopup extends Component {

    static propTypes = {
        className: PropTypes.any,
        handleTabToggle: PropTypes.any,
        isExpand: PropTypes.bool,
        totalPrice: PropTypes.bool,
        basePrice: PropTypes.number,
        oneTotalPrice: PropTypes.number,
        currency: PropTypes.string,
    };

    render() {
        const { className, handleTabToggle, isExpand, totalPrice, basePrice, oneTotalPrice, currency, showMap, listingURL, listBlockedDates, personalized, calculatedValues } = this.props;
        return (
            <>
                <a href={showMap ? listingURL : ''} target={'_blank'}
                    onClick={(e) => {
                        if (!showMap && totalPrice) {
                            e.preventDefault();
                            handleTabToggle(!isExpand)
                        } else {
                            void (0);
                        }
                    }}
                    className={cx(s.currencyText, s.cursorPointer, { ['totalTaxText']: totalPrice })}>
                    <ShowPrice totalPrice={totalPrice} oneTotalPrice={oneTotalPrice} basePrice={basePrice} currency={currency} listBlockedDates={listBlockedDates} personalized={personalized} calculatedValues={calculatedValues} />
                </a>
            </>
        );
    }
}

export default injectIntl(withStyles(s)(TotalPricePopup));